export const enum HelpGenericEvents {
	CLICK_CATEGORY = 'click_help_category',
	CLICK_QUESTION = 'click_help_question',
	CLICK_QUESTION_BTN = 'click_help_question_button',
	CLICK_CONTACT_BTN = 'click_help_contact',
	CLICK_CONTACT_LABEL = 'click_help_contact_',
}

export const enum ClickEventTypes {
	CLICK_INSIDE = 'click_inside',
	CLICK_OUTSIDE = 'click_outside',
}

export const NO_CATEGORY = 'no_category'
